export const registrationModalKey =
  'descriptions.event-landing.registration-modal';
export const binderSectionKey =
  'descriptions.event-landing.registration-modal.binder-section';
export const childrenInfoSectionKey =
  'descriptions.event-landing.registration-modal.children-info-section';
export const chooseLanguageSecionKey =
  'descriptions.event-landing.registration-modal.choose-language-section';
export const eventInfoSectionKey =
  'descriptions.event-landing.registration-modal.event-info-section';
export const registrSuccessModalKey =
  'descriptions.event-landing.registration-modal.success';
export const kitsInformationSectionKey =
  'descriptions.event-landing.registration-modal.kits-information-section';
export const ageLevelCalccualtorSectionKey = 'descriptions.calculate-child-age';
export const inputPlaceholdersKey = 'descriptions.input-placeholders';
export const inputLabelsKey = 'descriptions.input-labels';

export const stepOneKey =
  'descriptions.event-landing.registration-modal.step-one';
export const stepTwoKey =
  'descriptions.event-landing.registration-modal.step-two';
export const stepThreeKey =
  'descriptions.event-landing.registration-modal.step-three';
export const stepFourKey =
  'descriptions.event-landing.registration-modal.step-four';
export const stepFiveKey =
  'descriptions.event-landing.registration-modal.step-five';
